import { useEffect, useState } from 'react';

/** @see https://www.codemzy.com/blog/react-hook-scroll-direction-event-listener */

export const useScrollDirection = (minimumScroll = 0) => {
  const [scrollDirection, setScrollDirection] = useState<'up' | 'down' | null>(
    null
  );

  useEffect(() => {
    let lastScrollY = window.pageYOffset;

    const updateScrollDirection = () => {
      const scrollY = window.pageYOffset;
      const direction =
        scrollY > minimumScroll
          ? scrollY > lastScrollY
            ? 'down'
            : 'up'
          : null;
      if (
        direction !== scrollDirection &&
        (scrollY < minimumScroll ||
          scrollY - lastScrollY > 10 ||
          scrollY - lastScrollY < -10)
      ) {
        setScrollDirection(direction);
      }
      lastScrollY = scrollY > 0 ? scrollY : 0;
    };
    window.addEventListener('scroll', updateScrollDirection);
    return () => {
      window.removeEventListener('scroll', updateScrollDirection);
    };
  }, [scrollDirection, minimumScroll]);

  return scrollDirection;
};
